const Event = require('../../../entities/Event');
const { Age } = require('../../Constants');
const EventNames = require('../../Names/EventNames');

class DevelopmentOfScience extends Event {
    constructor(){
        super(
            Age.AgeA,
            EventNames.DevelopmentOfScience,
            "Each civilization scores 2 science.",
            {}
        )
    }
}

module.exports = DevelopmentOfScience;